import { Slower } from "./Slower";
export async function loadExternalSlowInteraction(engine) {
  let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  await engine.addInteractor("externalSlow", container => new Slower(container), refresh);
}
export * from "./Options/Classes/Slow";
export * from "./Options/Interfaces/ISlow";